module.exports = __webpack_public_path__ + "static/media/hand-point-left.74789010.svg";